export default "/assets/markers/deliveries_on.png"